import React from 'react';
import '../styles/Header.css';

const Header = ({ scrolled, headerVisible, setIsMenuOpen, scrollTo }) => {
  return (
    <nav
      id="navbar"
      className={`fixed w-full z-50 transition-all duration-500 py-4 md:py-6 px-4 md:px-12 flex justify-between items-center ${scrolled ? 'bg-white shadow-lg text-emerald-700 py-2 md:py-3' : 'bg-transparent text-white'} ${headerVisible ? 'translate-y-0' : '-translate-y-full'}`}
    >
      <div className="flex items-center gap-2 md:gap-3 group cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        <img 
          src="/images/logo.png" 
          alt="Jaladhara Logo" 
          className={`transition-all duration-300 ${scrolled ? 'h-12 md:h-14' : 'h-16 md:h-18'} drop-shadow-[0_0_20px_rgba(255,255,255,0.6)] group-hover:scale-105 filter brightness-110`} 
        />
        <div className="flex flex-col text-left">
          <span className="serif italic text-[1.1rem] md:text-2xl font-bold leading-none tracking-tight">Jaladhara</span>
          <span className="text-[7px] md:text-[10px] uppercase tracking-[0.2em] opacity-80 text-left">Tourism & Camping</span>
        </div>
      </div>

      {/* Desktop Nav */}
      <div className="hidden lg:flex items-center gap-10">
        <ul className="flex space-x-8 font-medium text-xs uppercase tracking-widest">
          <li><button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="hover:text-emerald-400 transition font-bold">Home</button></li>
          <li><button onClick={() => scrollTo('accommodations')} className="hover:text-emerald-400 transition font-bold">Stay</button></li>
          <li><button onClick={() => scrollTo('wonders')} className="hover:text-emerald-400 transition font-bold">Discover</button></li>
          <li><button onClick={() => scrollTo('contact')} className="hover:text-emerald-400 transition font-bold">Contact</button></li>
        </ul>
        <button onClick={() => scrollTo('contact')} className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 rounded-full transition duration-300 text-xs font-bold shadow-lg shadow-emerald-900/30">
          BOOK NOW
        </button>
      </div>

      <button
        className="lg:hidden text-2xl p-2 bg-emerald-900/20 backdrop-blur rounded-lg flex items-center justify-center min-w-[44px] min-h-[44px]"
        onClick={() => setIsMenuOpen(true)}
      >
        <i className={`fas fa-bars ${scrolled ? 'text-emerald-700' : 'text-white'}`}></i>
      </button>
    </nav>
  );
};

export default Header;
